// YERİ: src/app/domains/site/sections/testimonials.section.ts
// Müvekkil yorumları — alıntı kartları.

import { inject, Component, computed, input } from '@angular/core';
import { MIcon } from '@/app/shared/ui/m-icon';
import { SiteConfig, cfg } from './section.model';
import { SiteChromeText } from '../core/site-chrome-text';

interface Quote { quote: string; author: string; role?: string; }

@Component({
  selector: 'sec-testimonials',
  standalone: true,
  imports: [MIcon],
  template: `
    <section id="testimonials" class="bg-white py-24 dark:bg-neutral-950">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl text-center">
          <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p>
          <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">{{ title() }}</h2>
        </div>
        <div class="mt-16 grid gap-6 lg:grid-cols-3">
          @for (q of items(); track q.author) {
            <figure class="flex flex-col rounded-2xl border border-neutral-200 bg-neutral-50 p-7 dark:border-neutral-800 dark:bg-neutral-900">
              <m-icon name="quote" class="!size-8" style="color:var(--site-accent)" />
              <blockquote class="mt-4 flex-auto text-neutral-700 dark:text-neutral-300">"{{ q.quote }}"</blockquote>
              <figcaption class="mt-6 border-t border-neutral-200 pt-4 dark:border-neutral-800">
                <p class="font-semibold text-neutral-900 dark:text-white">{{ q.author }}</p>
                @if (q.role) { <p class="text-sm text-neutral-500">{{ q.role }}</p> }
              </figcaption>
            </figure>
          }
        </div>
      </div>
    </section>
  `,
})
export class TestimonialsSection {
  protected text = inject(SiteChromeText);
  config = input<SiteConfig>({});
  protected eyebrow = computed(() => cfg(this.config(), 'eyebrow', 'Referanslar'));
  protected title = computed(() => cfg(this.config(), 'title', this.text.t('fb.muvekkillerimizNeDiyor')));
  protected items = computed<Quote[]>(() => cfg<Quote[]>(this.config(), 'items', [
    { quote: this.text.t('fb.surecinHerAsamasindaBilgilendirildim'), author: 'A. Kaya', role: this.text.t('fb.bireyselMuvekkil') },
    { quote: this.text.t('fb.sirketimizinTicariUyusmazliginiBuyuk'), author: 'B. Şahin', role: this.text.t('fb.kurumsalMuvekkil') },
    { quote: this.text.t('fb.aileHukukuDavamdaGosterdikleri'), author: 'C. Yıldız', role: this.text.t('fb.bireyselMuvekkil') },
  ]));
}
